import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import LoadingSkeleton from '../../../common/loading-skeleton';
import Block from '../../block';
export const RelatedUrlsBlockResolvingView = ({
  testId,
  ...blockProps
}) => /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
  testId: testId
}), /*#__PURE__*/React.createElement(LoadingSkeleton, {
  height: 1.55,
  width: 22
}));